'use client';

import type {ReactNode} from 'react';
import {type FC} from 'react';
import {QueryClientProvider} from '@tanstack/react-query';
import {MotionConfig} from 'motion/react';

import {getQueryClient} from './get-query-client';

interface Props {
	children: ReactNode;
}

export const AppProvider: FC<Props> = ({children}) => {
	const queryClient = getQueryClient();

	return (
		<MotionConfig reducedMotion="user">
			<QueryClientProvider client={queryClient}>
				{children}
			</QueryClientProvider>
		</MotionConfig>
	);
};
